import IPrayer from "../../interfaces/IPrayer";
import IApiResponse from "../../interfaces/IApiResponse";
import DexieDB from '../../data/DexieDB'
import SuccessApiResponse from "../../data/SuccessApiResponse";
import { PrayerStatusValues } from "../../data/PrayerStatus";
import { IPrayerService } from "../PrayerService";

const PrayerServiceWeb: IPrayerService = {
    createPrayer: (prayer) => {
        const dbResponse: Promise<IApiResponse<IPrayer>> = DexieDB.transaction('rw', DexieDB.prayers, async()  => {
            const newPrayer: any  = prayer;
            delete newPrayer.id;
            return DexieDB.prayers.add({...newPrayer}).then((prayerId)=>{
                prayer.id = prayerId;
                const response = {...SuccessApiResponse, Data: prayer};
                response.Message.UserMessage = 'SUCCESS: ADDED NEW PRAYER.';
                return response;
            });
        }).catch((error)=>{
            const response = {
                Data: prayer,
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<IPrayer>;
        });

        return dbResponse;
    },

    getPrayer: (prayerId) =>  {
        const dbResponse: Promise<IApiResponse<IPrayer>> = DexieDB.transaction('r', DexieDB.prayers, async()  => {
            return DexieDB.prayers.get(prayerId).then((result)=>{
                if(result) {
                    return  {...SuccessApiResponse, Data: result};
                } else {
                    return {
                        Data: undefined,
                        Success: false,
                        Message: { UserMessage: 'FAILED: COULD NOT FIND PRAYER', ServerMessage: 'FAILED TO GET' }
                    }
                }
            });
        }).catch((error)=>{
            const response = {
                Data: undefined,
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<IPrayer>;
        });

        return dbResponse;
    },

    getPrayersByStatus: (prayerStatus: PrayerStatusValues) => {
        const dbResponse: Promise<IApiResponse<IPrayer[]>> = DexieDB.transaction('r', DexieDB.prayers, async()  => {
                return DexieDB.prayers.where({status: prayerStatus}).sortBy('order').then(prayers => {
                    return  {...SuccessApiResponse, Data: prayers};
                });
        }).catch((error)=>{
            const response = {
                Data: undefined,
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<IPrayer[]>;
        });

        return dbResponse;
    },

    getAllPrayers: () => {
        const dbResponse: Promise<IApiResponse<IPrayer[]>> = DexieDB.transaction('r', DexieDB.prayers, async()  => {
                return  DexieDB.prayers.orderBy('order').toArray().then(prayers => {
                    return {...SuccessApiResponse, Data: prayers};
                })
    }).catch((error)=>{
        const response = {
            Data: undefined,
            Success: false,
            Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
        }
        return response as IApiResponse<IPrayer[]>;
    });

    return dbResponse;
    },

    updatePrayer: (prayer, isSyncUpdate?) => {
        // If this an update from a cloud sync don't modify the date
        const updatedPrayer = isSyncUpdate ? prayer : {...prayer, modifiedDate: new Date(Date.now())};
        const dbResponse: Promise<IApiResponse<IPrayer>> = DexieDB.transaction('rw', DexieDB.prayers, async()  => {
            return DexieDB.prayers.put({...updatedPrayer}).then((result)=>{
                const response = {...SuccessApiResponse, Data: prayer};
                response.Message.UserMessage = 'SUCCESS: UPDATED PRAYER.';
                return response;
            });
        }).catch((error)=>{
            const response = {
                Data: prayer,
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<IPrayer>;
        });

        return dbResponse;
    },

    updatePrayers: (prayers) => {
        const dbResponse: Promise<IApiResponse<boolean>> = DexieDB.transaction('rw', DexieDB.prayers, async()  => {
            return DexieDB.prayers.bulkPut(prayers).then((result)=>{
                return {...SuccessApiResponse, Data: true};
            });
        }).catch((error)=>{
            const response = {
                Data: false,
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<boolean>;
        });

        return dbResponse;
    },

    // This is no longer used so that syncing with the cloud will know to remove it from other devices
    deletePrayer: (prayer) => {
        const dbResponse: Promise<IApiResponse<boolean>> = DexieDB.transaction('rw', DexieDB.prayers, async()  => {
            return DexieDB.prayers.delete(prayer.id).then((result)=>{
                return {...SuccessApiResponse, Data: true};
            });
        }).catch((error)=>{
            const response = {
                Data: false,
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<boolean>;
        });

        return dbResponse;
    },
}

export default PrayerServiceWeb;